<template>
  <div id="dashboard-twr">
    <WizardAlert section="dashboardTwr" alertClass="my-4">
      <template v-slot:text>
        <p>
          {{ $t('views.dashboardDetail.twr.wizard.a1') }}
        </p>
        <p>
          {{ $t('views.dashboardDetail.twr.wizard.a2') }}
        </p>
        <p>
          {{ $t('views.dashboardDetail.twr.wizard.b1') }}
          <a href="https://www.filios.app/blog/rentabilidad-inversiones/" target="_blank">
            {{ $t('views.dashboardDetail.twr.wizard.b2') }}
          </a>
        </p>
      </template>
    </WizardAlert>

    <v-card
      class="px-5 py-2 mt-4 mb-0 elevation-0"
      :class="{ 'sticky-filters': user.preferences.stickyFilters }"
    >
      <PositionsFiltersAndViewMode
        ref="positionsFilters"
        type="position"
        :positionType.sync="positionType"
        showZeroPositions
        @filterPositions="filterPositions"
      />
    </v-card>

    <SomePositionIncomplete />

    <v-row>
      <v-col cols="12" lg="12" class="mt-4 py-0">
        <SummaryPortfolioPerformance ref="portfolioPerformanceYieldTwr" type="yield" calc="twr" />
      </v-col>
      <v-col cols="12" lg="12" class="mt-4 py-0">
        <SummaryPortfolioPerformance ref="portfolioPerformanceYieldRor" type="yield" calc="ror" />
      </v-col>
      <v-col cols="12" lg="12" class="mt-4 py-0">
        <SummaryPortfolioPerformance ref="portfolioPerformanceYieldMwr" type="yield" calc="mwr" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { get } from 'lodash'
import { mapState } from 'vuex'
import PositionsFiltersAndViewMode from '@/views/components/common/positions/PositionsFiltersAndViewMode'
import WizardAlert from '@/views/components/common/WizardAlert'
import SummaryPortfolioPerformance from '@/views/components/dashboardDetail/summary/SummaryPortfolioPerformance'
import SomePositionIncomplete from '@/views/components/common/positions/SomePositionIncomplete.vue'

export default {
  components: {
    PositionsFiltersAndViewMode,
    WizardAlert,
    SummaryPortfolioPerformance,
    SomePositionIncomplete,
  },
  data() {
    return {
      positionType: null,
      filters: {},
    }
  },
  computed: {
    ...mapState(['user']),
  },
  watch: {
    positionType: {
      async handler() {
        if (this.positionType) await this.updateFilters()
      },
    },
  },
  async mounted() {
    this.positionType = get(this.user, 'preferences.defaultPositionsNeCash', null)
      ? 'allNeCash'
      : 'all'
  },
  methods: {
    async updateFilters() {
      if (this.$refs.positionsFilters) await this.$refs.positionsFilters.updateFilters()
      this.init()
    },
    async init() {
      const filters = JSON.parse(JSON.stringify(this.filters))
      const type = this.positionType

      if (this.$refs.portfolioPerformanceYieldRor)
        this.$refs.portfolioPerformanceYieldRor.load({ filters, positionType: type })
      if (this.$refs.portfolioPerformanceYieldTwr)
        this.$refs.portfolioPerformanceYieldTwr.load({ filters, positionType: type })
      if (this.$refs.portfolioPerformanceYieldMwr)
        this.$refs.portfolioPerformanceYieldMwr.load({ filters, positionType: type })
    },
    async filterPositions(filters) {
      this.filters = JSON.parse(JSON.stringify(filters))
      this.init(filters)
    },
  },
}
</script>
